// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3t13bOXb3edDyMTK1updZR","heading":"_1jRNwHfmt_nr6HrJli4fzo","error":"_1Mwsq34qSZ6Smpga4NXkzp"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/containers/NotFoundPage.less
 ** module id = 848
 ** module chunks = 0
 **/